// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import useApi from "../CustomHooks/useApi";
// import {
//     fetchAepsBalance,
//     fetchWalletBalance,
//     fetchLienBalance,
// } from "../Store/Slices/WalletSlice";
// import Image1 from "../Assets/BalanceImageCarousel/image1.jpeg";
// import Image2 from "../Assets/BalanceImageCarousel/image2.jpeg";
// import Image3 from "../Assets/BalanceImageCarousel/image3.jpeg";
// import Image4 from "../Assets/BalanceImageCarousel/image4.jpeg";

// const DistributorBalance = () => {

//     const images = [Image1, Image2, Image3, Image4];
//     const [currentSlide, setCurrentSlide] = useState(0);

//     useEffect(() => {
//         const interval = setInterval(() => {
//             setCurrentSlide((prev) => (prev + 1) % images.length);
//         }, 3000);

//         return () => clearInterval(interval);
//     }, []);

//     const [currentTime, setCurrentTime] = useState(new Date());

//     useEffect(() => {
//         const timer = setInterval(() => {
//             setCurrentTime(new Date());
//         }, 1000);

//         return () => clearInterval(timer);
//     }, []);



//     const dispatch = useDispatch();
//     const {
//         merchant_account_no,
//         username,
//         userId
//     } = useSelector((s) => s.auth.employeeDetails) || {};

//     const {
//         merchant_shop_name,
//         distributor_name,
//         distributor_mobile
//     } = useSelector((s) => s.auth.employeeDetails.others) || {};

//     const [showAepsTransfer, setShowAepsTransfer] = useState(false);
//     const [transferAepsAmount, setTransferAepsAmount] = useState("");
//     const [isLoadingAeps, setIsLoadingAeps] = useState(false);
//     const [aepsMessage, setAepsMessage] = useState("");

//     const { callApi: transferAepsToMain } = useApi(
//         "/business/wallet/aeps/settle",
//         "POST"
//     );

//     const [wallet, setWallet] = useState(0);
//     const [commission, setCommission] = useState(0);
//     const { balance, aepsBalance } = useSelector((s) => s.wallet);
//     const [showCommissionTransfer, setShowCommissionTransfer] = useState(false);
//     const [transferCommissionAmount, setTransferCommissionAmount] = useState("");
//     const [isLoadingCommission, setIsLoadingCommission] = useState(false);
//     const [commissionMessage, setCommissionMessage] = useState("");

//     const { callApi: transferCommissionToMain } = useApi(
//         "/business/wallet/settle",
//         "POST"
//     );

//     const { callApi: walletApi } = useApi(
//         `/business/wallet/balance/v1?mid=${username}&account_no=${merchant_account_no}`,
//         "GET"
//     );

//     const { callApi: commissionApi } = useApi(
//         `/business/wallet/view/settle/balance?mid=${username}&account_no=${merchant_account_no}`,
//         "GET"
//     );

//     const now = new Date();
//     const hours = now.getHours();

//     let greeting = "Good Evening";
//     if (hours < 12) greeting = "Good Morning";
//     else if (hours < 17) greeting = "Good Afternoon";


//     useEffect(() => {
//         (async () => {
//             const w = await walletApi();
//             const c = await commissionApi();
//             setWallet(w?.balance || 0);
//             setCommission(c?.balance || 0);
//         })();

//         dispatch(fetchWalletBalance());
//         dispatch(fetchAepsBalance());
//         dispatch(fetchLienBalance());
//     }, []);

//     useEffect(() => {
//         dispatch(fetchWalletBalance());
//         dispatch(fetchAepsBalance());
//         dispatch(fetchLienBalance());
//     }, [dispatch]);

//     const handleAepsToMainTransfer = async () => {
//         if (!transferAepsAmount || transferAepsAmount <= 0) {
//             setAepsMessage("Please enter a valid amount.");
//             return;
//         }

//         setIsLoadingAeps(true);
//         setAepsMessage("");

//         try {
//             const res = await transferAepsToMain(
//                 null,
//                 `?amount=${parseFloat(transferAepsAmount)}&userId=${userId}`
//             );

//             if (res.status === "SUCCESS") {
//                 setAepsMessage("AEPS balance transferred to Main Wallet successfully.");
//                 setTransferAepsAmount("");

//                 dispatch(fetchWalletBalance());
//                 dispatch(fetchAepsBalance());
//             } else {
//                 setAepsMessage(res.message || "Transfer failed.");
//             }
//         } catch (err) {
//             setAepsMessage("Error transferring AEPS balance.");
//         } finally {
//             setIsLoadingAeps(false);
//             setTransferAepsAmount("");

//             setTimeout(() => {
//                 setShowAepsTransfer(false);
//                 setAepsMessage("");
//             }, 1500);
//         }
//     };

//     const handleCommissionToMainTransfer = async () => {
//         if (!transferCommissionAmount || transferCommissionAmount <= 0) {
//             setCommissionMessage("Please enter a valid amount.");
//             return;
//         }

//         setIsLoadingCommission(true);
//         setCommissionMessage("");

//         try {
//             const res = await transferCommissionToMain(
//                 null,
//                 `?amount=${parseFloat(transferCommissionAmount)}&userId=${userId}`
//             );

//             if (res.status === "SUCCESS") {
//                 setCommissionMessage("Commission transferred to Main Wallet successfully.");

//                 dispatch(fetchWalletBalance());
//                 dispatch(fetchLienBalance());
//             } else {
//                 setCommissionMessage(res.message || "Commission transfer failed.");
//             }
//         } catch (err) {
//             setCommissionMessage("Error transferring commission.");
//         } finally {
//             setIsLoadingCommission(false);
//             setTransferCommissionAmount("");

//             setTimeout(() => {
//                 setShowCommissionTransfer(false);
//                 setCommissionMessage("");
//             }, 1500);
//         }
//     };

//   return (
//   <section className="w-full pt-3">

//     {/* Mobile Full Width | Desktop Centered */}
//     <div className="w-full">

//     <div className="rounded-2xl sm:rounded-3xl bg-gradient-to-r from-[#162A5C] to-[#1E2F6B] text-white p-4 sm:p-8 shadow-lg sm:shadow-xl mx-2 sm:mx-0">
//         {/* HEADER */}
//         <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-1">

//           <div className="font-semibold text-xl lg:text-3xl sm:text-3xl">
//               {currentTime.toLocaleDateString("en-IN", {
//                 weekday: "long",
//                 day: "numeric",
//                 month: "long",
//                 year: "numeric",
//               })}
//               {" • "}
//               {currentTime.toLocaleTimeString("en-IN")} - {greeting}, {merchant_shop_name} JI 👋
//             </div>
//         </div>

//         {/* BALANCES */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mt-4">

//           {/* MAIN */}
//         <div className="bg-white/10 rounded-2xl p-4 sm:p-6 border border-white/20 backdrop-blur-md">
//             <p className="text-xl text-gray-300">Main</p>
//             <h1 className="text-xl sm:text-3xl lg:text-4xl font-bold mt-1 break-words">
//               ₹{balance?.toLocaleString() || 0}
//             </h1>
//           </div>

//           {/* AEPS */}
//         <div className="bg-white/10 rounded-2xl p-4 sm:p-6 border border-white/20 backdrop-blur-md">
//             <p className="text-xl text-gray-300">AEPS</p>
//             <h1 className="text-xl sm:text-3xl lg:text-4xl font-bold mt-1 break-words">
//               ₹{aepsBalance?.toLocaleString() || 0}
//             </h1>

//             <button
//               onClick={() => setShowAepsTransfer(true)}
//               className="mt-3 w-full bg-indigo-500 hover:bg-indigo-600 py-2 rounded-md text-xl"
//             >
//               Transfer
//             </button>
//           </div>

//           {/* COMMISSION */}
//          <div className="bg-white/10 rounded-2xl p-4 sm:p-6 border border-white/20 backdrop-blur-md">
//             <p className="text-xl text-gray-300">Commission</p>
//             <h1 className="text-xl sm:text-3xl lg:text-4xl font-bold mt-1 break-words">
//               ₹{commission?.toLocaleString() || 0}
//             </h1>

//             <button
//               onClick={() => setShowCommissionTransfer(true)}
//               className="mt-3 w-full bg-indigo-500 hover:bg-indigo-600 py-2 rounded-md text-xl"
//             >
//               Transfer
//             </button>
//           </div>
//         </div>

//         {/* ================= AEPS TRANSFER ================= */}
//         {showAepsTransfer && (
//           <div className="mt-5 bg-white/10 p-4 rounded-xl border border-white/20">

//             <input
//               type="number"
//               value={transferAepsAmount}
//               onChange={(e) => setTransferAepsAmount(e.target.value)}
//               placeholder="Enter AEPS Amount"
//               className="w-full bg-[#0F1E3D] text-white border border-gray-500 rounded-md px-4 py-2"
//             />

//             <div className="flex flex-col sm:flex-row gap-3 mt-3">
//               <button
//                 onClick={handleAepsToMainTransfer}
//                 disabled={isLoadingAeps}
//                 className="flex-1 bg-indigo-500 hover:bg-indigo-600 py-2 rounded-md"
//               >
//                 {isLoadingAeps ? "Processing..." : "Confirm"}
//               </button>

//               <button
//                 onClick={() => setShowAepsTransfer(false)}
//                 className="flex-1 bg-red-500 hover:bg-red-600 py-2 rounded-md"
//               >
//                 Cancel
//               </button>
//             </div>

//             {aepsMessage && (
//               <p className="text-xl mt-2 text-yellow-300">
//                 {aepsMessage}
//               </p>
//             )}
//           </div>
//         )}

//         {/* ================= COMMISSION TRANSFER ================= */}
//         {showCommissionTransfer && (
//           <div className="mt-5 bg-white/10 p-4 rounded-xl border border-white/20">

//             <input
//               type="number"
//               value={transferCommissionAmount}
//               onChange={(e) =>
//                 setTransferCommissionAmount(e.target.value)
//               }
//               placeholder="Enter Commission Amount"
//               className="w-full bg-[#0F1E3D] text-white border border-gray-500 rounded-md px-4 py-2"
//             />

//             <div className="flex flex-col sm:flex-row gap-3 mt-3">
//               <button
//                 onClick={handleCommissionToMainTransfer}
//                 disabled={isLoadingCommission}
//                 className="flex-1 bg-indigo-500 hover:bg-indigo-600 py-2 rounded-md"
//               >
//                 {isLoadingCommission ? "Processing..." : "Confirm"}
//               </button>

//               <button
//                 onClick={() => setShowCommissionTransfer(false)}
//                 className="flex-1 bg-red-500 hover:bg-red-600 py-2 rounded-md"
//               >
//                 Cancel
//               </button>
//             </div>

//             {commissionMessage && (
//               <p className="text-xl mt-2 text-yellow-300">
//                 {commissionMessage}
//               </p>
//             )}
//           </div>
//         )}

//       </div>
//     </div>
//   </section>
// );


// };

// export default DistributorBalance;

// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import useApi from "../CustomHooks/useApi";
// import {
//   fetchAepsBalance,
//   fetchWalletBalance,
//   fetchLienBalance,
// } from "../Store/Slices/WalletSlice";
// import Image1 from "../Assets/BalanceImageCarousel/image1.jpeg";
// import Image2 from "../Assets/BalanceImageCarousel/image2.jpeg";
// import Image3 from "../Assets/BalanceImageCarousel/image3.jpeg";
// import Image4 from "../Assets/BalanceImageCarousel/image4.jpeg";

// const WalletOverview = () => {

//   const images = [Image1, Image2, Image3, Image4];
//   const [currentSlide, setCurrentSlide] = useState(0);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentSlide((prev) => (prev + 1) % images.length);
//     }, 3000);

//     return () => clearInterval(interval);
//   }, []);

//   const [currentTime, setCurrentTime] = useState(new Date());

//   useEffect(() => {
//     const timer = setInterval(() => {
//       setCurrentTime(new Date());
//     }, 1000);

//     return () => clearInterval(timer);
//   }, []);



//   const dispatch = useDispatch();
//   const {
//     merchant_account_no,
//     username,
//     userId
//   } = useSelector((s) => s.auth.employeeDetails) || {};

//   const {
//     merchant_shop_name,
//     distributor_name,
//     distributor_mobile
//   } = useSelector((s) => s.auth.employeeDetails.others) || {};

//   const [showAepsTransfer, setShowAepsTransfer] = useState(false);
//   const [transferAepsAmount, setTransferAepsAmount] = useState("");
//   const [isLoadingAeps, setIsLoadingAeps] = useState(false);
//   const [aepsMessage, setAepsMessage] = useState("");

//   const { callApi: transferAepsToMain } = useApi(
//     "/business/wallet/aeps/settle",
//     "POST"
//   );

//   const [wallet, setWallet] = useState(0);
//   const [commission, setCommission] = useState(0);
//   const { balance, aepsBalance } = useSelector((s) => s.wallet);
//   const [showCommissionTransfer, setShowCommissionTransfer] = useState(false);
//   const [transferCommissionAmount, setTransferCommissionAmount] = useState("");
//   const [isLoadingCommission, setIsLoadingCommission] = useState(false);
//   const [commissionMessage, setCommissionMessage] = useState("");

//   const { callApi: transferCommissionToMain } = useApi(
//     "/business/wallet/settle",
//     "POST"
//   );

//   const { callApi: walletApi } = useApi(
//     `/business/wallet/balance/v1?mid=${username}&account_no=${merchant_account_no}`,
//     "GET"
//   );

//   const { callApi: commissionApi } = useApi(
//     `/business/wallet/view/settle/balance?mid=${username}&account_no=${merchant_account_no}`,
//     "GET"
//   );

//   const now = new Date();
//   const hours = now.getHours();

//   let greeting = "Good Evening";
//   if (hours < 12) greeting = "Good Morning";
//   else if (hours < 17) greeting = "Good Afternoon";


//   useEffect(() => {
//     (async () => {
//       const w = await walletApi();
//       const c = await commissionApi();
//       setWallet(w?.balance || 0);
//       setCommission(c?.balance || 0);
//     })();

//     dispatch(fetchWalletBalance());
//     dispatch(fetchAepsBalance());
//     dispatch(fetchLienBalance());
//   }, []);

//   useEffect(() => {
//     dispatch(fetchWalletBalance());
//     dispatch(fetchAepsBalance());
//     dispatch(fetchLienBalance());
//   }, [dispatch]);

//   const handleAepsToMainTransfer = async () => {
//     if (!transferAepsAmount || transferAepsAmount <= 0) {
//       setAepsMessage("Please enter a valid amount.");
//       return;
//     }

//     setIsLoadingAeps(true);
//     setAepsMessage("");

//     try {
//       const res = await transferAepsToMain(
//         null,
//         `?amount=${parseFloat(transferAepsAmount)}&userId=${userId}`
//       );

//       if (res.status === "SUCCESS") {
//         setAepsMessage("AEPS balance transferred to Main Wallet successfully.");
//         setTransferAepsAmount("");

//         dispatch(fetchWalletBalance());
//         dispatch(fetchAepsBalance());
//       } else {
//         setAepsMessage(res.message || "Transfer failed.");
//       }
//     } catch (err) {
//       setAepsMessage("Error transferring AEPS balance.");
//     } finally {
//       setIsLoadingAeps(false);
//       setTransferAepsAmount("");

//       setTimeout(() => {
//         setShowAepsTransfer(false);
//         setAepsMessage("");
//       }, 1500);
//     }
//   };

//   const handleCommissionToMainTransfer = async () => {
//     if (!transferCommissionAmount || transferCommissionAmount <= 0) {
//       setCommissionMessage("Please enter a valid amount.");
//       return;
//     }

//     setIsLoadingCommission(true);
//     setCommissionMessage("");

//     try {
//       const res = await transferCommissionToMain(
//         null,
//         `?amount=${parseFloat(transferCommissionAmount)}&userId=${userId}`
//       );

//       if (res.status === "SUCCESS") {
//         setCommissionMessage("Commission transferred to Main Wallet successfully.");

//         dispatch(fetchWalletBalance());
//         dispatch(fetchLienBalance());
//       } else {
//         setCommissionMessage(res.message || "Commission transfer failed.");
//       }
//     } catch (err) {
//       setCommissionMessage("Error transferring commission.");
//     } finally {
//       setIsLoadingCommission(false);
//       setTransferCommissionAmount("");

//       setTimeout(() => {
//         setShowCommissionTransfer(false);
//         setCommissionMessage("");
//       }, 1500);
//     }
//   };

//   return (
//     <section className="w-full bg-[#F4F6FA] pt-3">

//       <div className="mx-auto rounded-2xl overflow-hidden bg-[#162A5C] shadow-md text-white">

//         <div className="px-4 sm:px-6 py-4">

//           {/* ================= HEADER ================= */}
//           <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 text-lg sm:text-sm">

//             {/* LEFT → Greeting */}
//             <div className="font-semibold text-lg sm:text-sm">
//               {currentTime.toLocaleDateString("en-IN", {
//                 weekday: "long",
//                 day: "numeric",
//                 month: "long",
//                 year: "numeric",
//               })}
//               {" • "}
//               {currentTime.toLocaleTimeString("en-IN")} - {greeting}, {merchant_shop_name} JI 👋
//             </div>

//             {/* RIGHT → Balances */}
//             <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4 text-lg sm:text-sm">

//               {/* Main */}
//               <div className="flex justify-between sm:justify-start sm:items-center gap-1">
//                 <span className="text-gray-300">Main:</span>
//                 <span className="font-semibold">
//                   ₹{balance?.toLocaleString() || 0}
//                 </span>
//               </div>

//               <span className="hidden sm:block text-gray-400">|</span>

//               {/* AEPS */}
//               <div className="flex flex-col sm:flex-row sm:items-center sm:gap-2 gap-2">
//                 <div className="flex justify-between sm:justify-start gap-1">
//                   <span className="text-gray-300">Aeps:</span>
//                   <span className="font-semibold">
//                     ₹{aepsBalance?.toLocaleString() || 0}
//                   </span>
//                 </div>

//                 <button
//                   onClick={() => setShowAepsTransfer(true)}
//                   className="w-full sm:w-auto sm:text-sm text-lg bg-indigo-500 hover:bg-indigo-600 px-2 py-1 rounded transition"
//                 >
//                   Transfer
//                 </button>
//               </div>

//               <span className="hidden sm:block text-gray-400">|</span>

//               {/* Commission */}
//               <div className="flex flex-col sm:flex-row sm:items-center sm:gap-2 gap-2">
//                 <div className="flex justify-between sm:justify-start gap-1">
//                   <span className="text-gray-300">Commission:</span>
//                   <span className="font-semibold">
//                     ₹{commission?.toLocaleString() || 0}
//                   </span>
//                 </div>

//                 <button
//                   onClick={() => setShowCommissionTransfer(true)}
//                   className="w-full sm:w-auto sm:text-sm text-lg bg-indigo-500 hover:bg-indigo-600 px-2 py-1 rounded transition"
//                 >
//                   Transfer
//                 </button>
//               </div>

//             </div>
//           </div>

//           {/* ================= AEPS TRANSFER ================= */}
//           {showAepsTransfer && (
//             <div className="mt-3 p-4 bg-[#1E2F6B] rounded-xl">
//               <input
//                 type="number"
//                 value={transferAepsAmount}
//                 onChange={(e) => setTransferAepsAmount(e.target.value)}
//                 placeholder="Enter AEPS Amount"
//                 className="w-full border border-gray-500 bg-[#0F1E3D] text-white rounded-md px-3 py-2 text-lg"
//               />

//               <div className="flex flex-col sm:flex-row gap-3 mt-3">
//                 <button
//                   onClick={handleAepsToMainTransfer}
//                   disabled={isLoadingAeps}
//                   className="flex-1 bg-indigo-500 hover:bg-indigo-600 py-2 rounded-md text-lg"
//                 >
//                   {isLoadingAeps ? "Processing..." : "Confirm"}
//                 </button>

//                 <button
//                   onClick={() => setShowAepsTransfer(false)}
//                   className="flex-1 bg-red-500 hover:bg-red-600 py-2 rounded-md text-lg"
//                 >
//                   Cancel
//                 </button>
//               </div>

//               {aepsMessage && (
//                 <p className="text-lg mt-2 text-yellow-300">{aepsMessage}</p>
//               )}
//             </div>
//           )}

//           {/* ================= COMMISSION TRANSFER ================= */}
//           {showCommissionTransfer && (
//             <div className="mt-3 p-4 bg-[#1E2F6B] rounded-xl">
//               <input
//                 type="number"
//                 value={transferCommissionAmount}
//                 onChange={(e) =>
//                   setTransferCommissionAmount(e.target.value)
//                 }
//                 placeholder="Enter Commission Amount"
//                 className="w-full border border-gray-500 bg-[#0F1E3D] text-white rounded-md px-3 py-2 text-lg"
//               />

//               <div className="flex flex-col sm:flex-row gap-3 mt-3">
//                 <button
//                   onClick={handleCommissionToMainTransfer}
//                   disabled={isLoadingCommission}
//                   className="flex-1 bg-indigo-500 hover:bg-indigo-600 py-2 rounded-md text-lg"
//                 >
//                   {isLoadingCommission ? "Processing..." : "Confirm"}
//                 </button>

//                 <button
//                   onClick={() => setShowCommissionTransfer(false)}
//                   className="flex-1 bg-red-500 hover:bg-red-600 py-2 rounded-md text-lg"
//                 >
//                   Cancel
//                 </button>
//               </div>

//               {commissionMessage && (
//                 <p className="text-lg mt-2 text-yellow-300">
//                   {commissionMessage}
//                 </p>
//               )}
//             </div>
//           )}

//         </div>
//       </div>
//     </section>

//   );





// };

// export default WalletOverview;

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useApi from "../CustomHooks/useApi";
import {
  fetchAepsBalance,
  fetchWalletBalance,
  fetchLienBalance,
  fetchSettlementBalance,
} from "../Store/Slices/WalletSlice";

const WalletOverview = () => {
  const dispatch = useDispatch();

  const {
    merchant_account_no,
    username,
  } = useSelector((s) => s.auth.employeeDetails) || {};

  const {
    merchant_shop_name,
  } = useSelector((s) => s.auth.employeeDetails?.others) || {};

  const { balance, aepsBalance } = useSelector((s) => s.wallet);

  const [commission, setCommission] = useState(0);
  const [currentTime, setCurrentTime] = useState(new Date());

  const { callApi: commissionApi } = useApi(
    `/business/wallet/view/settle/balance?mid=${username}&account_no=${merchant_account_no}`,
    "GET"
  );

  /* ================= TIME ================= */
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  /* ================= FETCH BALANCES ================= */
  useEffect(() => {
    (async () => {
      const c = await commissionApi();
      setCommission(c?.balance || 0);
    })();

    dispatch(fetchWalletBalance());
    dispatch(fetchAepsBalance());
    dispatch(fetchSettlementBalance());
    // dispatch(fetchLienBalance());
  }, [dispatch]);

  /* ================= GREETING ================= */
  const hours = currentTime.getHours();
  let greeting = "Good Evening";
  if (hours < 12) greeting = "Good Morning";
  else if (hours < 17) greeting = "Good Afternoon";

  return (
    <section className="w-full bg-[#F4F6FA] pt-3">
      {/* ================= DESKTOP (Greeting Only - Centered) ================= */}
      <div className="hidden lg:flex bg-[#162A5C] text-white rounded-2xl mx-6 shadow-md">
        <div className="w-full px-6 py-6 text-xl font-semibold text-center">
          {currentTime.toLocaleDateString("en-IN", {
            weekday: "long",
            day: "numeric",
            month: "long",
            year: "numeric",
          })}
          {" • "}
          {currentTime.toLocaleTimeString("en-IN")}
          {" — "}
          {greeting}, {merchant_shop_name} Ji 👋
        </div>
      </div>


      {/* ================= MOBILE (Greeting + Balance) ================= */}
      <div className="lg:hidden rounded-2xl overflow-hidden bg-[#162A5C] shadow-md text-white">
        <div className="px-4 py-4">

          {/* Greeting */}
          <div className="text-xl font-medium mb-4">
            {currentTime.toLocaleDateString("en-IN", {
              weekday: "long",
              day: "numeric",
              month: "long",
              year: "numeric",
            })}
            {" • "}
            {currentTime.toLocaleTimeString("en-IN")}
            <br />
            <span className="font-semibold">
              {greeting}, {merchant_shop_name} Ji 👋
            </span>
          </div>

          {/* Balances */}
          <div className="space-y-3 text-xl">

            <div className="flex justify-between bg-[#1E2F6B] px-4 py-3 rounded-xl">
              <span className="text-gray-300">Main Balance</span>
              <span className="font-semibold">
                ₹{balance?.toLocaleString() || 0}
              </span>
            </div>

            <div className="flex justify-between bg-[#1E2F6B] px-4 py-3 rounded-xl">
              <span className="text-gray-300">Commission Balance</span>
              <span className="font-semibold">
                ₹{commission?.toLocaleString() || 0}
              </span>
            </div>

          </div>

        </div>
      </div>

    </section>
  );

};

export default WalletOverview;




